<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    top="60px"
    :fullscreen="dialogFull"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    append-to-body
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title"> 查 看 </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <div style="height: calc(100vh - 400px); overflow: scroll">
      <avue-crud :table-loading="loading" :data="data" :option="option" ref="crud">
        <template slot="settlementFee" slot-scope="scope">
          {{ tool.money_format(scope.row.settlementFee) }}
        </template>
        <template slot="counterFee" slot-scope="scope">
          {{ tool.money_format(scope.row.counterFee) }}
        </template>
        <template slot="enterFee" slot-scope="scope">
          {{ tool.money_format(scope.row.enterFee) }}
        </template>
      </avue-crud>
    </div>
  </el-dialog>
</template>
<script>
import { getFeePayList as getList } from '@/api/v4ward/carv2/financial.js';
export default {
  data() {
    return {
      loading: false,
      dialogFull: false,
      dialogVisible: false,
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        searchMenuSpan: 12,
        selection: false,
        stripe: true,
        dialogClickModal: false,
        menu: false,
        header: false,
        addBtn: false,
        column: [
          {
            label: '账单日期',
            prop: 'billDate',
            searchSpan: 12,
            display: false,
            searchslot: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入到账时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单金额',
            prop: 'settlementFee',
            display: false,
            showWordLimit: true,
            align: 'right',
            slot: true,
            rules: [
              {
                required: true,
                message: '请输入提现单号',
                trigger: 'change',
              },
            ],
          },

          {
            label: '手续费',
            prop: 'counterFee',
            maxlength: 12,
            display: false,
            align: 'right',
            slot: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入到账金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '到账金额',
            prop: 'enterFee',
            maxlength: 12,
            display: false,
            align: 'right',
            slot: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入到账金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单状态',
            prop: 'status',
            type: 'select',
            dataType: 'string',
            display: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=tempcar_fee_pay_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择提现状态',
                trigger: 'change',
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    openDialog(data) {
      this.dialogVisible = true;
      this.loading = true;
      getList({ carTempcarFeePayIds: data.carTempcarFeePayIds })
        .then(({ data }) => {
          this.data = data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
